import {Injectable} from '@angular/core';
import {CalendarExporterGoogle} from './calendar-exporter.google';
import {CalendarExporterOutlook} from './calendar-exporter.outlook';
import {CalendarExporterYahoo} from './calendar-exporter.yahoo';
import {CalendarExporterText} from './calendar-exporter.text';
import {CalendarExporterAbstract, CalendarExporterType} from './calendar-exporter.abstract';

@Injectable({
  providedIn: 'root'
})
export class CalendarExporterFactory {
  getCalendar(type: CalendarExporterType): CalendarExporterAbstract {
    switch (type) {
      case 'google':
        return new CalendarExporterGoogle();
      case 'outlook':
        return new CalendarExporterOutlook();
      case 'yahoo':
        return new CalendarExporterYahoo();
      case 'iCalendar':
        return new CalendarExporterText('ics');
      case 'vCalendar':
        return new CalendarExporterText('vcs');
    }
  }
}
